import React from 'react';
import { BiLink } from "react-icons/bi";
import { scrollToCareer } from '../utils/scroll';

export default function Career() {
  return (
    <article id="career" className='bg-background w-full h-auto pb-20' >
      <div className='flex flex-row justify-center text-6xl font-banner-font text-black py-24 cursor-pointer' onClick={scrollToCareer}>
        <BiLink  className='text-white mr-4'/>
        <h2 className='border-b border-solid border-gray-300 pb-2 text-white'>CAREER</h2>
      </div>

      <ul className="w-full ">
        <li className='w-5/6 bg-white text-center mx-auto py-5 relative'>
          <div className='flex flex-col lg:flex-row mx-auto text-center '>
            <div className='w-full lg:w-1/3 lg:border-r-2 pr-5 border-gray-300 content-center '>
              <div className='w-52 h-52 mx-auto'>
                <img className='p-10 relative top-0 left-0' src="/images/career/ericsson.png" alt="ericsson logo" />
              </div>
            </div>                    
            <div className='w-full px-10 lg:w-2/3 text-left'>            
              <div>
                <h2 className='text-2xl font-bold'>에릭슨 캐나다</h2>
                <div className='w-full flex justify-between'>
                  <p className='mt-2 font-semibold'>소프트웨어 개발자 (풀스택) </p>
                  <p className='text-right justify-end items-end align-end text-gray-500'>2022.11 ~ 2024.03</p>
                </div>
              </div>
              <div className='my-5'>
                <p> ☑️ JavaScript 기반 5G Core 및 RAN 네트워크 슬라이스 품질 보증 <b>User Interface </b>(Dashboard) 개발</p> 
                <p >☑️ 제품 디자인, 아키텍처 설계, 개발, 테스터 및 문서화 작업 수행 (풀스택) </p>
                <p className=''>☑️ <b>주요 기술 스택</b>: JavaScript, Node.js, Ericsson SDK(React 베이스), OpenSearch, CSS</p>
                <p>☑️ <b>개발 환경 및 도구</b> : Adobe XD, JIRA, Confluence, Jenkins, Git/Github, Docker, Kubernetes</p>
              </div>
              <h4 className='font-bold border-l-4 border-black pl-5 h-auto flex mt-5 '>프론트엔드 (UI / UX)</h4>
              <ul className='mt-2'>
                <li>- 재사용 가능한 컴퍼넌트 개발 및 업데이트 </li>
                <li>- 요구사항 분석 및 서비스 구현/성능 최적화 진행  </li>
                <li>- Rest API 활용 데이터 통신 및 상호작용 구현</li>
                <li>- 사용성 테스트 진행(Usability testing) 및 테스트 결과 분석/솔루션 제안 (High-fidelity mock up 제공)</li>
                <li>- 반응형 디자인, 웹 접근성,  웹표준 고려한 UI/UX 개발 진행</li>
                <li>- 유닛, 컴퍼넌트 테스트 코드 작성 및 크로스 브라우징 테스트 수행</li>
              </ul>
              <h4 className='font-bold border-l-4 border-black pl-5 h-auto flex mt-5'>백엔드</h4>
              <ul className='mt-2'>
                <li>- Node.js 기반 백엔드 서비스 개발</li>
                <li>- 조건부 검색, 페이지네이션 등을 통한 성능 최적화 진행 </li>
                <li>- Open Search 쿼리 사용을 통한 데이터 수집 및 가공</li>
                <li>- 사용자 맞춤 기능(타이틀, 필터 등) 제공을 위한 백엔드 로직 개발</li>
                <li>- 유닛/컴퍼넌트 테스트 수행 </li>
              </ul>
              <h4 className='font-bold border-l-4 border-black pl-5 h-auto flex mt-5  '>그 외</h4>
              <ul className='mt-2'>
                <li>- 코드리뷰</li>
                <li>- 디버깅 작업</li>
                <li>- 3PP 관리 업무</li>
                <li>- 네트워크 엔지니어, 앱/프로덕트 테스팅 팀 등 다양한 팀들과 협업</li>
                <li>- Agile 소프트웨어 개발 프로세스 경험</li>
              </ul>

            </div>
          </div>
          <div className='big-leaf-parent absolute bottom-0 -left-36'>
              <img className="big-leaf" src="https://www.demimaisons.be/themes/demimaisons/assets/images/shape-region.png" alt="Shape leaf" />
          </div>
        </li>
        <li className='w-5/6 bg-white text-center mx-auto py-5 mt-10'>
          <div className='flex flex-col-reverse lg:flex-row mx-auto text-center'>                   
            <div className='w-full lg:w-2/3 text-left px-10'>            
              <div>
                <h2 className='text-2xl font-bold'>캐나다 통계청</h2>
                <div className='w-full flex justify-between'>
                  <p className='mt-2 font-semibold'>프론트엔드 개발자 </p>
                  <p className='text-gray-500'>2022.05 ~ 2022.11</p>
                </div>

              </div>
              <div className='my-5'>
                <p> 통계청 내부 고객사 요청 맞춤 웹사이트를 제작하는 부서에서 근무하였습니다.
                    기존 공기업 틀에 벗어나 재미있는 사용자 경험을 전달하고자 Parallax project를 진행하였습니다.
                </p>
    
                <p className='mt-3'>☑️ <b>주요 기술 스택</b>: JavaScript, CSS, HTML</p>
                <p>☑️ <b>개발 환경 및 도구</b> : Drupal, Git/Github </p>
              </div>

              <h4 className='text-semibold border-l-4 border-black pl-5 h-auto flex mt-5 '>프론트엔드</h4>
              <ul className='mt-2'>
                <li>- Parallax 웹사이트 개발</li>
                <li>- 다국어 지원(영어/불어)(i18n) </li>
                <li>- 반응형 디자인 제공</li>
                <li>- 웹 접근성 및 웹 표준 준수</li>
                <li>- UI 디자이너와 긴밀한 협업 진행</li>
              </ul>
            </div>
            <div className='w-full lg:w-1/3 lg:border-l-2 border-gray-300 content-center'>
              <div className='w-52 h-52 mx-auto items-center '>
                <img className='p-5 relative top-0 left-0' src="/images/career/statcan.jpeg" alt="statistics canada logo" />
              </div>
            </div>
          </div>
        </li>
      </ul>

    </article>
  );
}

